/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_AppServices_CompanyService_BrandingPackageAssignmentDto } from '../models/Wealthlane_CustomerService_AppServices_CompanyService_BrandingPackageAssignmentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrandingPackageQueryService {

    /**
     * @returns Wealthlane_CustomerService_AppServices_CompanyService_BrandingPackageAssignmentDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiBrandingPackageAssignmentOptions(): CancelablePromise<Array<Wealthlane_CustomerService_AppServices_CompanyService_BrandingPackageAssignmentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/branding-package/assignment-options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
